export const cupSizes = [
	{
		cm: [18, 19],
		cup: 65,
		regularSize: ['70A']
	},
	{
		cm: [20, 21],
		cup: 70,
		regularSize: ['75A', '70B']
	},
	{
		cm: [22, 23],
		cup: 75,
		regularSize: ['80A','75B', '70C']

	},
	{
		cm: [24, 25],
		cup: 80,
		regularSize: ['85A', '80B', '75C']
	},
	{
		cm: [26, 27],
		cup: 85,
		regularSize: ['90A', '85B', '80C', '75D', '70E']
	},
	{
		cm: [28, 29],
		cup: 90,
		regularSize: ['95A', 
		'90B',
		'85C',
		'80D',
		'75E',
		'70F']
	},
	{
		cm: [30, 31],
		cup: 95,
		regularSize: ['100A',
			'95B',
			'90C',
			'85D',
			'80E',
			'75F']
	},
	{
		cm: [32, 33],
		cup: 100,
		regularSize: [
			'100B',
			'95C',
			'90D',
			'85E',
			'80F']
	},
]

export const bandSizes = [
	{
		cm: [63, 67],
		band: 65
	},
	{
		cm: [68, 72],
		band: 70
	},
	{
		cm: [73, 77],
		band: 75
	},
	{
		cm: [78, 82],
		band: 80
	},
	{
		cm: [83, 87],
		band: 85
	},
	{
		cm: [88, 92],
		band: 90
	},
	{
		cm: [93, 97],
		band: 95
	},
	{
		cm: [98, 102],
		band: 100
	},
	{
		cm: [103, 107],
		band: 105
	},
	{
		cm: [103, 107],
		band: 110
	},
	{
		cm: [108, 112],
		band: 65
	},
	{
		cm: [113, 117],
		band: 115
	},
	{
		cm: [118, 122],
		band: 120
	},
	{
		cm: [123, 127],
		band: 125
	},
]
